import _ from 'lodash'
import { useEffect, useRef } from 'react'
import { currentPageFlowPhase, batchSendI13nPageViewByPageKey } from '../../../../lib/i13nUtil'

const useI13N = (i13nMethods, i13nData, pageFlow, postfix = 'batch') => {
  const {
    proposalType,
    queryStringListingIds,
    reservation
  } = i13nData
  const {
    sendI13nPageViewByPageKey
  } = i13nMethods
  const flowRef = useRef(null)

  useEffect(() => {
    const phase = currentPageFlowPhase(pageFlow)
    if (_.isEmpty(phase) || (flowRef.current === phase)) { return }
    flowRef.current = phase
    batchSendI13nPageViewByPageKey(sendI13nPageViewByPageKey, proposalType, queryStringListingIds, phase, postfix, reservation)
  }, [sendI13nPageViewByPageKey, pageFlow, proposalType, queryStringListingIds, postfix, reservation])
}

export default useI13N
